export default {
  data() {
    return {
      selectedData: [],
    }
  },
  methods: {
    onSelectChange(selection) {
      this.selectedData = selection;
    },
    onDelete(rowData) {
      const deleteIds = rowData
        ? [rowData.dataId]
        : this.selectedData.map((item) => item.dataId);

      if (!deleteIds.length) {
        return;
      }

      this.$confirm("确认删除本条数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.doDelete(deleteIds);
      });
    },
    deleteSelection() {
      this.onDelete();
    },
    doDelete(deleteIds) {
      this.$q.newProduct.delProduct({fragment: deleteIds}).then(({ code, data }) => {
        const isSuccess = code == 200;

        if (isSuccess) {
          this.$notify.success({
            title: "成功",
            message: `评审产品删除成功！`,
          });
        } else {
          this.$notify.error({
            title: "错误",
            data,
          });
        }

        if (isSuccess) {
          this.init();
        }
      });
    },
    selectConfirm() {
      if(this.selectedData.length == 0) {
        this.$message.error('请勾选参考数据');
        return;
      }
      this.$bus.$emit('selectSku', this.selectedData);
      // 删除该路由tag
      this.$store.dispatch('tagsView/delView', this.$route)
      this.$router.replace('/newProduct/newproduct-add')
    }
  }
}